import type {ReactElement} from 'react';
import React from 'react';
import useDefaultPanelClose from '@Panels/hooks/useDefaultPanelClose';
import PosterEditorColorPanel from '@Panels/poster-editor-color-panel';
import type {RGBA} from '@Utils/color.util';
import {updateLastAddedTextColor} from '@Components/poster-editor/library/poster-editor-library';
import {useUpdateEffect} from 'ahooks';
import {useSingleActivePosterItemId} from '@Hooks/poster-editor/useSingleActivePosterItemId';
import {useGetKeyFromFillOfTextStylesOfActiveItem} from '@Hooks/poster-editor/useGetKeyFromFillOfTextStylesOfActiveItem';

interface PosterEditorLayoutFillPanelProps {
  panelId: string;
}

export default function PosterEditorLayoutFillPanel({...props}: PosterEditorLayoutFillPanelProps): ReactElement | null {
  const onClose = useDefaultPanelClose(props.panelId);
  const activeItemId = useSingleActivePosterItemId();
  const activeItem = activeItemId ? window.posterEditor?.whiteboard?.getItemForId(activeItemId) : undefined;
  const itemFillType = useGetKeyFromFillOfTextStylesOfActiveItem('fillType');
  const itemFillColor = useGetKeyFromFillOfTextStylesOfActiveItem('fillColor');

  useUpdateEffect((): void => {
    onClose();
  }, [activeItemId]);

  if (!activeItem) {
    return null;
  }

  if (!itemFillColor || itemFillType === undefined) {
    return null;
  }

  if (!activeItem.isMenu() && !activeItem.isTableItem() && !activeItem.isTab()) {
    return null;
  }

  const updateFillColor = (fillColor: RGBA[], undoable = true): void => {
    void activeItem.updateFromObject(
      {
        textStyles: {
          fill: {
            fillColor,
          },
        },
        list: {
          fill: {
            fillColor,
          },
        },
      },
      {undoable}
    );
    updateLastAddedTextColor(fillColor[0]);
  };

  return (
    <PosterEditorColorPanel
      showInitialBackButton={false}
      panelId={props.panelId}
      fillObject={{fillType: itemFillType, fillColor: itemFillColor}}
      onChangeColor={updateFillColor}
      onClose={onClose}
    />
  );
}
